import { memo, useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
// import { FixedSizeList as List } from 'react-window';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { S } from './PlannedRoutePanel.styles';
import { PlannedRoutePanelProps } from './PlannedRoutePanel.interfaces';
import { FormattedMessage } from 'react-intl';
import { CloseButton } from 'shared/CloseButton/CloseButton';
import { RouteCard } from './RouteCard/RouteCard';
import { getPlannedRoutesLoadingStateSelector, guidePlannedRoutes } from 'store/UserStore/selectors';
import Lottie from 'lottie-web';
import lottie_farout_spinning_arrow from "../../../static/lottie_farout_spinning_arrow.json";

const PlannedRoutePanelComponent: React.FC<PlannedRoutePanelProps> = ({
  onRouteChanged,
  onCloseClick
}) => {

  const plannedRoutes = useSelector(guidePlannedRoutes);
  const isPlannedRoutesLoading = useSelector(getPlannedRoutesLoadingStateSelector);

  // let route: PlannedRoute = {
  //   parseObj:"asdas",
  //   objectId:"asd",
  //   routeName:"Route Name",
  //   pins: [],
  //   totalDescent: 1,
  //   totalAscent: 2,
  //   routeLength: 1324312,
  //   guideId: "guideId",
  //   updatedAt: new Date(),
  //   isNew: false,
  //   isEdited: false,
  //   isDeleted: false,
  //   isEnabled: true
  // };
  // routes = [route, 
  // ];
  
  const Row = useCallback(
    ({ data: { plannedRoutes }, index, style }) => {
      let route = plannedRoutes[index]
      return (
        // <div
        //   style={style}
        //   onClick={() => onRouteClick && onRouteClick(route)}
        // >
        <div>
          <RouteCard
            route={route}
            onRouteChanged={onRouteChanged}
          />
        </div>
      );
    },
    [onRouteChanged]
  );

  const animationContainer = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (animationContainer.current) {
      Lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: lottie_farout_spinning_arrow,
      });
    }
  }, [animationContainer]);

  const getItemSize = useCallback((index: number) => {
      if (plannedRoutes){
          const title = plannedRoutes[index].routeName;
          const lines = Math.ceil(title.length / 43); // adjust 40 based on font/container width
          return 60 + lines * 31; // base + per-line height
        }
      return 0;
  }, [plannedRoutes]);

  return (
    <S.Container>
      <S.Header>
        <S.Title><FormattedMessage id="planned_routes"/></S.Title>
        <CloseButton onClick={onCloseClick} />
      </S.Header>
        {!isPlannedRoutesLoading && plannedRoutes !== null ? (
          <S.ListContainer>
            <AutoSizer>
              {({ height, width }) => (
                <List
                  height={height}
                  itemCount={plannedRoutes.length}
                  itemSize={getItemSize}
                  width={width}
                  itemData={{ plannedRoutes }}
                >
                  {Row}
                </List>
              )}
            </AutoSizer>
          </S.ListContainer>
        ) : (
           <div ref={animationContainer} style={{alignItems: 'center', textAlign:'center', justifyContent: 'center', width: '70', height: "25%", marginTop: '47%', padding:50}}/>
        )}
    </S.Container>
  );
};

export const PlannedRoutePanel = memo(PlannedRoutePanelComponent, isEqual);
